var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultisearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.051 45.188c-4.259 5.028-9.086 10.728-9.086 17.831 0 .68-.8.714-.965.714-.29 0-.965-.069-.965-.714 0-7.111-4.785-12.757-9.413-18.217-4.7-5.545-9.559-11.279-9.559-18.6a19.937 19.937 0 0 1 39.874 0 18.677 18.677 0 0 1-2.523 9.114 1 1 0 0 0 1.754.961A20.624 20.624 0 0 0 56.937 26.2a21.937 21.937 0 0 0-43.874 0c0 8.052 5.1 14.071 10.033 19.891 4.6 5.424 8.939 10.547 8.939 16.924A2.754 2.754 0 0 0 35 65.733a2.754 2.754 0 0 0 2.965-2.714c0-6.37 4.378-11.54 8.613-16.539a1 1 0 0 0-1.527-1.292Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.17 34.451a12.046 12.046 0 1 0-1.419 1.409l10.4 10.4a1 1 0 0 0 1.414-1.414ZM35 36.683a10.092 10.092 0 1 1 10.092-10.092A10.1 10.1 0 0 1 35 36.683Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.761a5.831 5.831 0 1 0 5.831 5.83A5.837 5.837 0 0 0 35 20.761Zm0 9.661a3.831 3.831 0 1 1 3.831-3.831A3.835 3.835 0 0 1 35 30.422Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultisearch);
export default __webpack_public_path__ + "static/media/multisearch.1731956b653f7f67759eba6557707c8f.svg";
export { ForwardRef as ReactComponent };